import * as z from "zod";

export const createMessagingGroup = {
  name: "createMessagingGroup" as const,
  input: z.object({
    name: z.string().min(1, "Name is required"),
    channelIds: z.array(z.string()).min(1, "At least one channel is required"),
  }),
  output: z.object({
    _id: z.string(),
    name: z.string(),
    channelIds: z.array(z.string()),
    createdAt: z.date(),
    updatedAt: z.date(),
  }),
};
